import { createContext, useContext, useEffect, useState } from 'react';

import { useMutation } from '@apollo/client';
import { SEEN_NEW_FEATURE } from './operations';

const TutorialContext = createContext();

export const TutorialProvider = (props) => {
  const [tutorial, setTutorial] = useState(false);
  const [enable, setEnabled] = useState(false);

  useEffect(() => {
    //TODO remove in a while
    localStorage.removeItem('hide-walkthrough');
  }, []);

  const [seenNewFeature] = useMutation(SEEN_NEW_FEATURE);

  const setSeenNewFeature = (feature) => {
    seenNewFeature({ variables: { feature } });
  };

  return (
    <TutorialContext.Provider
      value={{
        hasTutorial: enable,
        tutorial,
        setTutorial,
        setSeenNewFeature,
        setEnabled,
      }}
    >
      {props.children}
    </TutorialContext.Provider>
  );
};

export const useTutorialContext = () => useContext(TutorialContext);
